module.exports = __webpack_public_path__ + "img/MELBET.1c4a7d61.svg";